import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=4f2b89e8&"
import script from "./addContact.vue?vue&type=script&lang=js&"
export * from "./addContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports